import React from 'react';
import { Text } from '@clockout-dev/design-elements';
import FreeAdvancesPanel from '../FreeAdvancesPanel';
import PromoGroupsSection from './PromoGroupsSection';
import PromoGroupDrawer from './PromoGroupDrawer';
import styles from './styles/freeAdvances.module.scss';

/**
 * The Free Advances sub-tab, split into two independent mechanisms:
 *
 * - General: the existing FreeAdvancesPanel, unchanged. Part of `fi_info`,
 *   saved with the Fee Structure tab's own Save button.
 * - Groups: member-specific promo groups. Lives in its own tables/REST
 *   behind the `feature:free_advance_promos:enabled` scope, so `panels`
 *   only renders it when the scope is granted — for every other FI this
 *   section simply doesn't exist.
 */
function FreeAdvancesTab({ rules = {}, handlers = {}, panels = {} }) {
    const memberPromos = panels.memberPromos;

    return (
        <div className={styles.tab}>
            <div>
                <div className={styles.sectionHeader}>
                    <Text as="span" size="m" className={styles.sectionTitle}>
                        General
                    </Text>
                </div>
                <Text as="span" size="s" className={styles.sectionDescription}>
                    Grant all users a number of fee-free advances.
                </Text>
                <FreeAdvancesPanel
                    rules={rules.freeAdvanceRules}
                    onAdd={handlers.addFreeAdvanceRule}
                    onRemove={handlers.removeFreeAdvanceRule}
                    onUpdate={handlers.updateFreeAdvanceRule}
                />
            </div>

            {memberPromos?.visible ? (
                <>
                    <hr className={styles.divider} />
                    <div>
                        <div className={styles.sectionHeader}>
                            <Text as="span" size="m" className={styles.sectionTitle}>
                                Groups
                            </Text>
                        </div>
                        <Text as="span" size="s" className={styles.sectionDescription}>
                            Grant specific member_ids a number of fee-free advances within a time window. Groups take
                            precedence over the General rules above.
                        </Text>
                        <PromoGroupsSection
                            groups={memberPromos.groups}
                            loading={memberPromos.loadingGroups}
                            onAddGroup={memberPromos.onAddGroup}
                            onOpenMembers={memberPromos.onOpenMembers}
                            onEditGroup={memberPromos.onEditGroup}
                            onDeleteGroup={memberPromos.onDeleteGroup}
                        />
                        <PromoGroupDrawer
                            drawer={memberPromos.drawer}
                            canManage={memberPromos.canManage}
                            onClose={memberPromos.onCloseDrawer}
                            onFieldChange={memberPromos.onDrawerFieldChange}
                            onAddMember={memberPromos.onStageAddMember}
                            onImportMembersCsv={memberPromos.onImportMembersCsv}
                            onRemoveMember={memberPromos.onStageRemoveMember}
                            onSave={memberPromos.onSaveDrawer}
                        />
                    </div>
                </>
            ) : null}
        </div>
    );
}

export default FreeAdvancesTab;
